import { ReactNode } from 'react';
import { LocationCountry } from '../../entities';

type LocationCountryCaseProps = {
  value?: LocationCountry | Array<LocationCountry>;
  children?: ReactNode;
  default?: boolean;
};

const LocationCountryCase = ({ children }: LocationCountryCaseProps) => {
  return <>{children}</>;
};

export default LocationCountryCase;
